import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement("circle", { cx: 12, cy: 12, r: 12, fill: "currentColor", opacity: 0.2 }),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M7 9.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5m3.334 5A4.167 4.167 0 1 0 7 16.167h10a4.167 4.167 0 1 0-3.334-1.667zm6.666 0a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5",
      clipRule: "evenodd"
    }
  )
);
var SvgCircledVoicemailFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var CircledVoicemailFilled_default = SvgCircledVoicemailFilled;

export { CircledVoicemailFilled_default as default };
